import React from 'react';
import { X } from 'lucide-react';
import JobForm from './JobForm';
import type { Job } from '../../types/job';

interface EditJobPopupProps {
  job: Job;
  onClose: () => void;
  onSuccess: () => void;
}

export default function EditJobPopup({ job, onClose, onSuccess }: EditJobPopupProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-dark-800 rounded-lg max-w-3xl w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Edit Opportunity</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <JobForm
          job={job}
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      </div>
    </div>
  );
}